// Vendor imports
const _ = require('lodash')
const Immutable = require('immutable')
const { createSelector } = require('reselect')
// Shared imports
const sharedUtils = require('shared/utils')

const isVisible = createSelector(
  state => state.searchForm,
  searchForm => !!(searchForm && searchForm.isVisible)
)

const supersearchQueryRegexp = createSelector(
  state => state.searchForm.value,
  query => sharedUtils.fuzzyMatcherRegexp(query)
)

const supersearchQuerySuggestions = createSelector(
  [
    state => state.searchForm.supersearchSuggestions,
    state => state.searchForm.value,
    supersearchQueryRegexp
  ],
  (supersearchSuggestions, query, queryRegexp) => {
    if (!query) {
      return Immutable.List()
    }
    return supersearchSuggestions.filter(suggestion => (
      queryRegexp.test(suggestion.complete) ||
      suggestion.names.some(name => queryRegexp.test(name))
    ))
    .slice(0, 10)
  }
)

const suggestions = createSelector(
  [
    supersearchQuerySuggestions,
    state => state.searchForm.googleSuggestions,
    state => state.searchForm.userSuggestions
  ],
  (supersearchSuggestions, googleSuggestions, userSuggestions) => {
    const groupedResults = _.chain(Immutable.List([
      supersearchSuggestions,
      userSuggestions,
      googleSuggestions
    ]).toJS())
    .flatten()
    .uniqBy('complete')
    .groupBy('type')
    .value()
    return _.chain([
      groupedResults.contact,
      groupedResults.search,
      groupedResults.google
    ])
    .flatten()
    .compact()
    .value()
  }
)

module.exports = {
  isVisible,
  suggestions
}
